module.exports = __webpack_public_path__ + "img/Butterfly_00244.89c1724a.png";